import React from "react";
import styled, { keyframes } from "styled-components";
import * as PropTypes from "prop-types";

const ProgressBarContainer = styled.div`
  margin-right: 0.5rem;
  width: ${props => props.barWidth};
`;
const progressAnimation = width => keyframes`
  0%   { width: 5%; background-color: #66fff7;}
  100% { width: ${width}%; background-color: #03dac4; }
`;
const OuterProgressBar = styled.div`
  padding: 0.125rem;
  border-radius: 1rem;
  background: #312782;
`;
const InnerProgressBar = styled.div`
  height: 0.8rem;
  border-radius: 2rem;
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.05));
  transition: 0.4s linear;
  transition-property: width, background-color;
  
  // animation attributes
  width: ${props => props.width}%;
  background-color: #03dac4;
  animation: ${props => progressAnimation(props.width)} 5s;
`;


const OoProgressBar = ({ percentProgress, barWidth }) => (
    <ProgressBarContainer barWidth={barWidth}>
      <OuterProgressBar>
        <InnerProgressBar width={percentProgress} />
      </OuterProgressBar>
    </ProgressBarContainer>
);
OoProgressBar.propTypes = {
  percentProgress: PropTypes.string.isRequired,
  barWidth: PropTypes.string.isRequired,
};

export default OoProgressBar;